import { envelopeRegistry, RpcService } from '../Service';
import { SMD, ServiceDef, RpcResponse } from '../interfaces';

const isRpcResponse = (v: { [key: string]: any }): v is RpcResponse<any> => {
	return v.content !== undefined && v.headers !== undefined;
};

envelopeRegistry.set('JSON-RPC-2.0', {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	serialize(this: RpcService, smd: SMD, method: ServiceDef, data: any, options?: any) {
		const d = {
			id: this._requestId++,
			method: method.name,
			params: data,
			jsonrpc: '2.0'
		};
		return {
			data: JSON.stringify(d),
			handleAs: 'json',
			contentType: 'application/json',
			transport: 'POST'
		};
	},

	deserialize(o: { [key: string]: any }) {
		if (isRpcResponse(o)) {
			return o;
		}
		const obj = (o.responseText && JSON.parse(o.responseText)) || o;
		return obj.result;
	},

	namedParams: true
});
